import Colors from '@/theme/constants/Colors';
import { TableRow, styled, Typography } from '@mui/material';

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  borderBottom: `2px solid ${Colors.COLOR_WHITE_2}80`,
  '&:last-child td, &:last-child th': { borderBottom: 'none !important' },
}));

export const DialogContentStyled = styled(Typography)(({ theme }) => ({
  color: theme.palette.dark.dark_3,
}));
